
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { UpdateBarcodeOrderItemRequest } from "@/models/api/barcodeSystem/barcodeOrders/updateBarcodeOrderItem";
import { formatBool } from "@/utils";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeOrderItemUpdate extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  updateBarcodeOrderItemRequest: UpdateBarcodeOrderItemRequest;

  @Prop({default: null})
  validationMessages: string[];

  get statusOptions() : Array<any> {
    return this.updateBarcodeOrderItemRequest && this.updateBarcodeOrderItemRequest.orderItemStatuses ? 
      this.updateBarcodeOrderItemRequest.orderItemStatuses.map(x => ({ label: x.description, value: x.code })) :
      [];
  }

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }  
  
  get itemName(): string {
    return this.updateBarcodeOrderItemRequest
      ? this.updateBarcodeOrderItemRequest.itemName
      : ""; 
  } 
  
  set itemName(val: string){
  } 

  get statusDescription(): string{
    if(this.updateBarcodeOrderItemRequest)
    {
      var status = barcodeSystemModule.barcodeOrderItemStatuses.filter(x => x.code == this.updateBarcodeOrderItemRequest.status);
      if(status && status.length > 0)
        return status[0].description;
      return this.updateBarcodeOrderItemRequest.status;
    }
    return "";
  }
  
  set statusDescription(val: string){
  } 
  
  get damaged(): string {
    return this.updateBarcodeOrderItemRequest
      ? formatBool(this.updateBarcodeOrderItemRequest.isDamaged)
      : "No"; 
  } 
  
  set damaged(val: string){
  } 
  
  get itemDescription(): string {
    return this.updateBarcodeOrderItemRequest
      ? this.updateBarcodeOrderItemRequest.itemDescription
      : ""; 
  } 
  
  set itemDescription(val: string){
  }  
  
  get quantity(): number {
    return this.updateBarcodeOrderItemRequest
      ? this.updateBarcodeOrderItemRequest.quantity
      : 0; 
  } 
  
  set quantity(val: number){
  } 

  get itemScan(): string {
    return this.updateBarcodeOrderItemRequest
      ? this.updateBarcodeOrderItemRequest.itemScan
      : ""; 
  }
  
  set itemScan(val: string){
  }

  get groupScan(): string {
    return this.updateBarcodeOrderItemRequest
      ? this.updateBarcodeOrderItemRequest.groupScan
      : ""; 
  }

  set groupScan(val: string){
  }

  formatBool(val)
  {
    formatBool(val)
  }
  
  itemIsShort() : boolean
  {
    return this.updateBarcodeOrderItemRequest.status == 'M';
  }

  handleDamagedChanged() {
    if(this.updateBarcodeOrderItemRequest.isDamaged)
    {
      this.updateBarcodeOrderItemRequest.quantityDamaged = this.updateBarcodeOrderItemRequest.quantity;
    }
    else
    {
      this.updateBarcodeOrderItemRequest.quantityDamaged = 0;
      this.updateBarcodeOrderItemRequest.damageCode = null;
    }
  }
}
